import { authFetch } from "./authFetch";

const BASE_URL = window.env.API_BASE_URL;

export const fetchRecipients = async gatewayId => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/GetRecipients/${gatewayId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 404) {
      return [];
    }

    if (!response.ok) {
      throw new Error("Failed to fetch recipients");
    }

    return await response.json();
  } catch (error) {
    return [];
  }
};

export const addRecipient = async (gatewayId, emails) => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/AddRecipients/${gatewayId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Emails: emails }),
    });

    if (!response.ok) {
      throw new Error("Failed to add recipient");
    }

    return true;
  } catch (error) {
    return false;
  }
};

export const deleteRecipient = async (gatewayId, recipientId) => {
  try {
    const response = await authFetch(`${BASE_URL}/Gateway/DeleteRecipient/${gatewayId}/${recipientId}`, {
      method: "DELETE",
    });
    const text = await response.text();

    if (!response.ok) {
      throw new Error(text || "_unknownError");
    }
    return text;
  } catch (error) {
    throw error;
  }
};
